module.exports = {
	"contractName": "DragonFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "random1",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "random2",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				},
				{
					"name": "_dragonDen",
					"type": "address"
				}
			],
			"name": "setAccount",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "137:940:6:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;137:940:6;;;;;;",
	"deployedSourceMap": "137:940:6:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;225:193;;-1:-1:-1;;;;;225:193:6;;;;;;;;;-1:-1:-1;;;;;225:193:6;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;776:161:6;;8:9:-1;5:2;;;30:1;27;20:12;5:2;776:161:6;;;;;;;;;;;;;;;;;;;;;;;941:134;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;941:134:6;-1:-1:-1;;;;;941:134:6;;;;;;;;;;;;611:161;;8:9:-1;5:2;;;30:1;27;20:12;5:2;611:161:6;;;;422:185;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;422:185:6;-1:-1:-1;;;;;422:185:6;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;225:193:6;290:7;318:8;344;329:9;:7;:9::i;:::-;318:20;;355:9;:7;:9::i;:::-;344:20;;388:5;394:2;388:9;;;;;;;;;;;;;;;;;;;;;;399;:13;;-1:-1:-1;;;;;388:9:6;;;;399:13;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;399:13:6;377:36;;:::i;:::-;-1:-1:-1;;;;;377:36:6;;;;;;;;;;;;;;;;;;;;-1:-1:-1;377:36:6;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;370:43:6;225:193;-1:-1:-1;;;;225:193:6:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;776:161:6:-;912:5;:12;860:48;;;-1:-1:-1;;870:15:6;:19;860:48;;891:16;860:48;;;;;;;;;;;;;;;811:5;;912:12;852:72;;;;;;;;824:108;;776:161;:::o;941:134::-;653:5:29;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;1020:5:6;27:10:-1;;23:18;;;45:23;;1020:18:6;;;;-1:-1:-1;;;;;1020:18:6;;;-1:-1:-1;;1020:18:6;;;;;;;1044:9;27:10:-1;;23:18;;;45:23;;-1:-1;1044:26:6;;;;;;;;;;;;;;;;941:134::o;611:161::-;747:5;:12;695:48;;;-1:-1:-1;;705:15:6;:19;695:48;;726:16;695:48;;;;;;;;;;;;;;;646:5;;747:12;687:72;;;;;;422:185;508:4;535:15;560:9;535:35;;583:8;-1:-1:-1;;;;;583:17:6;;:19;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;583:19:6;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;583:19:6;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;583:19:6;;422:185;-1:-1:-1;;;;422:185:6:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;137:940:6:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"zeppelin-solidity/contracts/ownership/Ownable.sol\";\nimport \"./base/Level.sol\";\nimport \"./Dragon.sol\";\n\ncontract DragonFactory is Ownable, Level {\n  address[] owner;\n  address[] dragonDen;\n\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    uint8 r1 = random1();\n    uint8 r2 = random2();\n    return new Dragon(owner[r1], dragonDen[r2]);\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    Dragon instance = Dragon(_instance);\n    return instance.complete();\n  }\n\n  function random1() public returns (uint8) {\n    return\n      uint8(\n        uint256(keccak256(block.timestamp - 4, block.difficulty)) % owner.length\n      );\n  }\n\n  function random2() public returns (uint8) {\n    return\n      uint8(\n        uint256(keccak256(block.timestamp - 2, block.difficulty)) % owner.length\n      );\n  }\n\n  function setAccount(address _owner, address _dragonDen) public onlyOwner {\n    owner.push(_owner);\n    dragonDen.push(_dragonDen);\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/DragonFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/DragonFactory.sol",
		"exportedSymbols": {
			"DragonFactory": [
				911
			]
		},
		"id": 912,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 779,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:6"
			},
			{
				"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"file": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"id": 780,
				"nodeType": "ImportDirective",
				"scope": 912,
				"sourceUnit": 2923,
				"src": "26:59:6",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 781,
				"nodeType": "ImportDirective",
				"scope": 912,
				"sourceUnit": 2867,
				"src": "86:26:6",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Dragon.sol",
				"file": "./Dragon.sol",
				"id": 782,
				"nodeType": "ImportDirective",
				"scope": 912,
				"sourceUnit": 778,
				"src": "113:22:6",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 783,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2922,
							"src": "163:7:6",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$2922",
								"typeString": "contract Ownable"
							}
						},
						"id": 784,
						"nodeType": "InheritanceSpecifier",
						"src": "163:7:6"
					},
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 785,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "172:5:6",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 786,
						"nodeType": "InheritanceSpecifier",
						"src": "172:5:6"
					}
				],
				"contractDependencies": [
					777,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 911,
				"linearizedBaseContracts": [
					911,
					2866,
					2922
				],
				"name": "DragonFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 789,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 911,
						"src": "182:15:6",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_address_$dyn_storage",
							"typeString": "address[]"
						},
						"typeName": {
							"baseType": {
								"id": 787,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "182:7:6",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"id": 788,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "182:9:6",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_address_$dyn_storage_ptr",
								"typeString": "address[]"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 792,
						"name": "dragonDen",
						"nodeType": "VariableDeclaration",
						"scope": 911,
						"src": "201:19:6",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_address_$dyn_storage",
							"typeString": "address[]"
						},
						"typeName": {
							"baseType": {
								"id": 790,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "201:7:6",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"id": 791,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "201:9:6",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_address_$dyn_storage_ptr",
								"typeString": "address[]"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 821,
							"nodeType": "Block",
							"src": "299:119:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 799,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 794,
										"src": "305:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 800,
									"nodeType": "ExpressionStatement",
									"src": "305:7:6"
								},
								{
									"assignments": [
										802
									],
									"declarations": [
										{
											"constant": false,
											"id": 802,
											"name": "r1",
											"nodeType": "VariableDeclaration",
											"scope": 822,
											"src": "318:8:6",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"typeName": {
												"id": 801,
												"name": "uint8",
												"nodeType": "ElementaryTypeName",
												"src": "318:5:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 805,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 803,
											"name": "random1",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 866,
											"src": "329:7:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$_t_uint8_$",
												"typeString": "function () returns (uint8)"
											}
										},
										"id": 804,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "329:9:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "318:20:6"
								},
								{
									"assignments": [
										807
									],
									"declarations": [
										{
											"constant": false,
											"id": 807,
											"name": "r2",
											"nodeType": "VariableDeclaration",
											"scope": 822,
											"src": "344:8:6",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"typeName": {
												"id": 806,
												"name": "uint8",
												"nodeType": "ElementaryTypeName",
												"src": "344:5:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 810,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 808,
											"name": "random2",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 888,
											"src": "355:7:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$_t_uint8_$",
												"typeString": "function () returns (uint8)"
											}
										},
										"id": 809,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "355:9:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "344:20:6"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 813,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 789,
													"src": "388:5:6",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_address_$dyn_storage",
														"typeString": "address[] storage ref"
													}
												},
												"id": 815,
												"indexExpression": {
													"argumentTypes": null,
													"id": 814,
													"name": "r1",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "394:2:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "388:9:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 816,
													"name": "dragonDen",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 792,
													"src": "399:9:6",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_address_$dyn_storage",
														"typeString": "address[] storage ref"
													}
												},
												"id": 818,
												"indexExpression": {
													"argumentTypes": null,
													"id": 817,
													"name": "r2",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 807,
													"src": "409:2:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "399:13:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 812,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "377:10:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_address_$_t_address_$returns$_t_contract$_Dragon_$777_$",
												"typeString": "function (address,address) returns (contract Dragon)"
											},
											"typeName": {
												"contractScope": null,
												"id": 811,
												"name": "Dragon",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 777,
												"src": "381:6:6",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Dragon_$777",
													"typeString": "contract Dragon"
												}
											}
										},
										"id": 819,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "377:36:6",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Dragon_$777",
											"typeString": "contract Dragon"
										}
									},
									"functionReturnParameters": 798,
									"id": 820,
									"nodeType": "Return",
									"src": "370:43:6"
								}
							]
						},
						"documentation": null,
						"id": 822,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 795,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 794,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 822,
									"src": "249:15:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 793,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "249:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "248:17:6"
						},
						"payable": true,
						"returnParameters": {
							"id": 798,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 797,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 822,
									"src": "290:7:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 796,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "290:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "289:9:6"
						},
						"scope": 911,
						"src": "225:193:6",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 843,
							"nodeType": "Block",
							"src": "516:91:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 831,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 826,
										"src": "522:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 832,
									"nodeType": "ExpressionStatement",
									"src": "522:7:6"
								},
								{
									"assignments": [
										834
									],
									"declarations": [
										{
											"constant": false,
											"id": 834,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 844,
											"src": "535:15:6",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Dragon_$777",
												"typeString": "contract Dragon"
											},
											"typeName": {
												"contractScope": null,
												"id": 833,
												"name": "Dragon",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 777,
												"src": "535:6:6",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Dragon_$777",
													"typeString": "contract Dragon"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 838,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 836,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 824,
												"src": "560:9:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 835,
											"name": "Dragon",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 777,
											"src": "553:6:6",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Dragon_$777_$",
												"typeString": "type(contract Dragon)"
											}
										},
										"id": 837,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "553:17:6",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Dragon_$777",
											"typeString": "contract Dragon"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "535:35:6"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 839,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 834,
												"src": "583:8:6",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Dragon_$777",
													"typeString": "contract Dragon"
												}
											},
											"id": 840,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "complete",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 660,
											"src": "583:17:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$__$returns$_t_bool_$",
												"typeString": "function () external returns (bool)"
											}
										},
										"id": 841,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "583:19:6",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 830,
									"id": 842,
									"nodeType": "Return",
									"src": "576:26:6"
								}
							]
						},
						"documentation": null,
						"id": 844,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 827,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 824,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 844,
									"src": "448:17:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 823,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "448:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 826,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 844,
									"src": "467:15:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 825,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "467:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "447:36:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 830,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 829,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 844,
									"src": "508:4:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 828,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "508:4:6",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "507:6:6"
						},
						"scope": 911,
						"src": "422:185:6",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					},
					{
						"body": {
							"id": 865,
							"nodeType": "Block",
							"src": "653:119:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 862,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 855,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 852,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2927,
																			"src": "705:5:6",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 853,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "timestamp",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "705:15:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "34",
																		"id": 854,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "723:1:6",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_4_by_1",
																			"typeString": "int_const 4"
																		},
																		"value": "4"
																	},
																	"src": "705:19:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 856,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2927,
																		"src": "726:5:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 857,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "difficulty",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "726:16:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																],
																"id": 851,
																"name": "keccak256",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2931,
																"src": "695:9:6",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																	"typeString": "function () pure returns (bytes32)"
																}
															},
															"id": 858,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "695:48:6",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"id": 850,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "687:7:6",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint256_$",
															"typeString": "type(uint256)"
														},
														"typeName": "uint256"
													},
													"id": 859,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "687:57:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "%",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 860,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 789,
														"src": "747:5:6",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_address_$dyn_storage",
															"typeString": "address[] storage ref"
														}
													},
													"id": 861,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "747:12:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "687:72:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 849,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "672:5:6",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint8_$",
												"typeString": "type(uint8)"
											},
											"typeName": "uint8"
										},
										"id": 863,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "672:95:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"functionReturnParameters": 848,
									"id": 864,
									"nodeType": "Return",
									"src": "659:108:6"
								}
							]
						},
						"documentation": null,
						"id": 866,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "random1",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 845,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "627:2:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 848,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 847,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 866,
									"src": "646:5:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint8",
										"typeString": "uint8"
									},
									"typeName": {
										"id": 846,
										"name": "uint8",
										"nodeType": "ElementaryTypeName",
										"src": "646:5:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "645:7:6"
						},
						"scope": 911,
						"src": "611:161:6",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 887,
							"nodeType": "Block",
							"src": "818:119:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 884,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 877,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 874,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2927,
																			"src": "870:5:6",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 875,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "timestamp",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "870:15:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "32",
																		"id": 876,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "888:1:6",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_2_by_1",
																			"typeString": "int_const 2"
																		},
																		"value": "2"
																	},
																	"src": "870:19:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 878,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2927,
																		"src": "891:5:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 879,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "difficulty",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "891:16:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																],
																"id": 873,
																"name": "keccak256",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2931,
																"src": "860:9:6",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																	"typeString": "function () pure returns (bytes32)"
																}
															},
															"id": 880,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "860:48:6",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"id": 872,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "852:7:6",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint256_$",
															"typeString": "type(uint256)"
														},
														"typeName": "uint256"
													},
													"id": 881,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "852:57:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "%",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 882,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 789,
														"src": "912:5:6",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_address_$dyn_storage",
															"typeString": "address[] storage ref"
														}
													},
													"id": 883,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "912:12:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "852:72:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 871,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "837:5:6",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint8_$",
												"typeString": "type(uint8)"
											},
											"typeName": "uint8"
										},
										"id": 885,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "837:95:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"functionReturnParameters": 870,
									"id": 886,
									"nodeType": "Return",
									"src": "824:108:6"
								}
							]
						},
						"documentation": null,
						"id": 888,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "random2",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 867,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "792:2:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 870,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 869,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 888,
									"src": "811:5:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint8",
										"typeString": "uint8"
									},
									"typeName": {
										"id": 868,
										"name": "uint8",
										"nodeType": "ElementaryTypeName",
										"src": "811:5:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "810:7:6"
						},
						"scope": 911,
						"src": "776:161:6",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 909,
							"nodeType": "Block",
							"src": "1014:61:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 900,
												"name": "_owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 890,
												"src": "1031:6:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 897,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 789,
												"src": "1020:5:6",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_address_$dyn_storage",
													"typeString": "address[] storage ref"
												}
											},
											"id": 899,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "push",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1020:10:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_arraypush_nonpayable$_t_address_$returns$_t_uint256_$",
												"typeString": "function (address) returns (uint256)"
											}
										},
										"id": 901,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1020:18:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 902,
									"nodeType": "ExpressionStatement",
									"src": "1020:18:6"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 906,
												"name": "_dragonDen",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 892,
												"src": "1059:10:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 903,
												"name": "dragonDen",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 792,
												"src": "1044:9:6",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_address_$dyn_storage",
													"typeString": "address[] storage ref"
												}
											},
											"id": 905,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "push",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1044:14:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_arraypush_nonpayable$_t_address_$returns$_t_uint256_$",
												"typeString": "function (address) returns (uint256)"
											}
										},
										"id": 907,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1044:26:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 908,
									"nodeType": "ExpressionStatement",
									"src": "1044:26:6"
								}
							]
						},
						"documentation": null,
						"id": 910,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 895,
								"modifierName": {
									"argumentTypes": null,
									"id": 894,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2896,
									"src": "1004:9:6",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1004:9:6"
							}
						],
						"name": "setAccount",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 893,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 890,
									"name": "_owner",
									"nodeType": "VariableDeclaration",
									"scope": 910,
									"src": "961:14:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 889,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "961:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 892,
									"name": "_dragonDen",
									"nodeType": "VariableDeclaration",
									"scope": 910,
									"src": "977:18:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 891,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "977:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "960:36:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 896,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1014:0:6"
						},
						"scope": 911,
						"src": "941:134:6",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 912,
				"src": "137:940:6"
			}
		],
		"src": "0:1078:6"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/DragonFactory.sol",
		"exportedSymbols": {
			"DragonFactory": [
				911
			]
		},
		"id": 912,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 779,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:6"
			},
			{
				"absolutePath": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"file": "zeppelin-solidity/contracts/ownership/Ownable.sol",
				"id": 780,
				"nodeType": "ImportDirective",
				"scope": 912,
				"sourceUnit": 2923,
				"src": "26:59:6",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 781,
				"nodeType": "ImportDirective",
				"scope": 912,
				"sourceUnit": 2867,
				"src": "86:26:6",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/Dragon.sol",
				"file": "./Dragon.sol",
				"id": 782,
				"nodeType": "ImportDirective",
				"scope": 912,
				"sourceUnit": 778,
				"src": "113:22:6",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 783,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2922,
							"src": "163:7:6",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$2922",
								"typeString": "contract Ownable"
							}
						},
						"id": 784,
						"nodeType": "InheritanceSpecifier",
						"src": "163:7:6"
					},
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 785,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "172:5:6",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 786,
						"nodeType": "InheritanceSpecifier",
						"src": "172:5:6"
					}
				],
				"contractDependencies": [
					777,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 911,
				"linearizedBaseContracts": [
					911,
					2866,
					2922
				],
				"name": "DragonFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 789,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 911,
						"src": "182:15:6",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_address_$dyn_storage",
							"typeString": "address[]"
						},
						"typeName": {
							"baseType": {
								"id": 787,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "182:7:6",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"id": 788,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "182:9:6",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_address_$dyn_storage_ptr",
								"typeString": "address[]"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 792,
						"name": "dragonDen",
						"nodeType": "VariableDeclaration",
						"scope": 911,
						"src": "201:19:6",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_address_$dyn_storage",
							"typeString": "address[]"
						},
						"typeName": {
							"baseType": {
								"id": 790,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "201:7:6",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"id": 791,
							"length": null,
							"nodeType": "ArrayTypeName",
							"src": "201:9:6",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_address_$dyn_storage_ptr",
								"typeString": "address[]"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 821,
							"nodeType": "Block",
							"src": "299:119:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 799,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 794,
										"src": "305:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 800,
									"nodeType": "ExpressionStatement",
									"src": "305:7:6"
								},
								{
									"assignments": [
										802
									],
									"declarations": [
										{
											"constant": false,
											"id": 802,
											"name": "r1",
											"nodeType": "VariableDeclaration",
											"scope": 822,
											"src": "318:8:6",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"typeName": {
												"id": 801,
												"name": "uint8",
												"nodeType": "ElementaryTypeName",
												"src": "318:5:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 805,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 803,
											"name": "random1",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 866,
											"src": "329:7:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$_t_uint8_$",
												"typeString": "function () returns (uint8)"
											}
										},
										"id": 804,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "329:9:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "318:20:6"
								},
								{
									"assignments": [
										807
									],
									"declarations": [
										{
											"constant": false,
											"id": 807,
											"name": "r2",
											"nodeType": "VariableDeclaration",
											"scope": 822,
											"src": "344:8:6",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint8",
												"typeString": "uint8"
											},
											"typeName": {
												"id": 806,
												"name": "uint8",
												"nodeType": "ElementaryTypeName",
												"src": "344:5:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint8",
													"typeString": "uint8"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 810,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 808,
											"name": "random2",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 888,
											"src": "355:7:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$_t_uint8_$",
												"typeString": "function () returns (uint8)"
											}
										},
										"id": 809,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "355:9:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "344:20:6"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 813,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 789,
													"src": "388:5:6",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_address_$dyn_storage",
														"typeString": "address[] storage ref"
													}
												},
												"id": 815,
												"indexExpression": {
													"argumentTypes": null,
													"id": 814,
													"name": "r1",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 802,
													"src": "394:2:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "388:9:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 816,
													"name": "dragonDen",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 792,
													"src": "399:9:6",
													"typeDescriptions": {
														"typeIdentifier": "t_array$_t_address_$dyn_storage",
														"typeString": "address[] storage ref"
													}
												},
												"id": 818,
												"indexExpression": {
													"argumentTypes": null,
													"id": 817,
													"name": "r2",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 807,
													"src": "409:2:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint8",
														"typeString": "uint8"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "399:13:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 812,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "377:10:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$_t_address_$_t_address_$returns$_t_contract$_Dragon_$777_$",
												"typeString": "function (address,address) returns (contract Dragon)"
											},
											"typeName": {
												"contractScope": null,
												"id": 811,
												"name": "Dragon",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 777,
												"src": "381:6:6",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Dragon_$777",
													"typeString": "contract Dragon"
												}
											}
										},
										"id": 819,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "377:36:6",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Dragon_$777",
											"typeString": "contract Dragon"
										}
									},
									"functionReturnParameters": 798,
									"id": 820,
									"nodeType": "Return",
									"src": "370:43:6"
								}
							]
						},
						"documentation": null,
						"id": 822,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 795,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 794,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 822,
									"src": "249:15:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 793,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "249:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "248:17:6"
						},
						"payable": true,
						"returnParameters": {
							"id": 798,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 797,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 822,
									"src": "290:7:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 796,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "290:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "289:9:6"
						},
						"scope": 911,
						"src": "225:193:6",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 843,
							"nodeType": "Block",
							"src": "516:91:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 831,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 826,
										"src": "522:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 832,
									"nodeType": "ExpressionStatement",
									"src": "522:7:6"
								},
								{
									"assignments": [
										834
									],
									"declarations": [
										{
											"constant": false,
											"id": 834,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 844,
											"src": "535:15:6",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_Dragon_$777",
												"typeString": "contract Dragon"
											},
											"typeName": {
												"contractScope": null,
												"id": 833,
												"name": "Dragon",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 777,
												"src": "535:6:6",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Dragon_$777",
													"typeString": "contract Dragon"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 838,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 836,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 824,
												"src": "560:9:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 835,
											"name": "Dragon",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 777,
											"src": "553:6:6",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_Dragon_$777_$",
												"typeString": "type(contract Dragon)"
											}
										},
										"id": 837,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "553:17:6",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_Dragon_$777",
											"typeString": "contract Dragon"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "535:35:6"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 839,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 834,
												"src": "583:8:6",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_Dragon_$777",
													"typeString": "contract Dragon"
												}
											},
											"id": 840,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "complete",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 660,
											"src": "583:17:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$__$returns$_t_bool_$",
												"typeString": "function () external returns (bool)"
											}
										},
										"id": 841,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "583:19:6",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 830,
									"id": 842,
									"nodeType": "Return",
									"src": "576:26:6"
								}
							]
						},
						"documentation": null,
						"id": 844,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 827,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 824,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 844,
									"src": "448:17:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 823,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "448:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 826,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 844,
									"src": "467:15:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 825,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "467:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "447:36:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 830,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 829,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 844,
									"src": "508:4:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 828,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "508:4:6",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "507:6:6"
						},
						"scope": 911,
						"src": "422:185:6",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					},
					{
						"body": {
							"id": 865,
							"nodeType": "Block",
							"src": "653:119:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 862,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 855,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 852,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2927,
																			"src": "705:5:6",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 853,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "timestamp",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "705:15:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "34",
																		"id": 854,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "723:1:6",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_4_by_1",
																			"typeString": "int_const 4"
																		},
																		"value": "4"
																	},
																	"src": "705:19:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 856,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2927,
																		"src": "726:5:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 857,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "difficulty",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "726:16:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																],
																"id": 851,
																"name": "keccak256",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2931,
																"src": "695:9:6",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																	"typeString": "function () pure returns (bytes32)"
																}
															},
															"id": 858,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "695:48:6",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"id": 850,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "687:7:6",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint256_$",
															"typeString": "type(uint256)"
														},
														"typeName": "uint256"
													},
													"id": 859,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "687:57:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "%",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 860,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 789,
														"src": "747:5:6",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_address_$dyn_storage",
															"typeString": "address[] storage ref"
														}
													},
													"id": 861,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "747:12:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "687:72:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 849,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "672:5:6",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint8_$",
												"typeString": "type(uint8)"
											},
											"typeName": "uint8"
										},
										"id": 863,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "672:95:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"functionReturnParameters": 848,
									"id": 864,
									"nodeType": "Return",
									"src": "659:108:6"
								}
							]
						},
						"documentation": null,
						"id": 866,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "random1",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 845,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "627:2:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 848,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 847,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 866,
									"src": "646:5:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint8",
										"typeString": "uint8"
									},
									"typeName": {
										"id": 846,
										"name": "uint8",
										"nodeType": "ElementaryTypeName",
										"src": "646:5:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "645:7:6"
						},
						"scope": 911,
						"src": "611:161:6",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 887,
							"nodeType": "Block",
							"src": "818:119:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 884,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"arguments": [
																{
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"id": 877,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"leftExpression": {
																		"argumentTypes": null,
																		"expression": {
																			"argumentTypes": null,
																			"id": 874,
																			"name": "block",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 2927,
																			"src": "870:5:6",
																			"typeDescriptions": {
																				"typeIdentifier": "t_magic_block",
																				"typeString": "block"
																			}
																		},
																		"id": 875,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": false,
																		"lValueRequested": false,
																		"memberName": "timestamp",
																		"nodeType": "MemberAccess",
																		"referencedDeclaration": null,
																		"src": "870:15:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_uint256",
																			"typeString": "uint256"
																		}
																	},
																	"nodeType": "BinaryOperation",
																	"operator": "-",
																	"rightExpression": {
																		"argumentTypes": null,
																		"hexValue": "32",
																		"id": 876,
																		"isConstant": false,
																		"isLValue": false,
																		"isPure": true,
																		"kind": "number",
																		"lValueRequested": false,
																		"nodeType": "Literal",
																		"src": "888:1:6",
																		"subdenomination": null,
																		"typeDescriptions": {
																			"typeIdentifier": "t_rational_2_by_1",
																			"typeString": "int_const 2"
																		},
																		"value": "2"
																	},
																	"src": "870:19:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																},
																{
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"id": 878,
																		"name": "block",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 2927,
																		"src": "891:5:6",
																		"typeDescriptions": {
																			"typeIdentifier": "t_magic_block",
																			"typeString": "block"
																		}
																	},
																	"id": 879,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"memberName": "difficulty",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": null,
																	"src": "891:16:6",
																	"typeDescriptions": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																}
															],
															"expression": {
																"argumentTypes": [
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	{
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	}
																],
																"id": 873,
																"name": "keccak256",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 2931,
																"src": "860:9:6",
																"typeDescriptions": {
																	"typeIdentifier": "t_function_sha3_pure$__$returns$_t_bytes32_$",
																	"typeString": "function () pure returns (bytes32)"
																}
															},
															"id": 880,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"kind": "functionCall",
															"lValueRequested": false,
															"names": [],
															"nodeType": "FunctionCall",
															"src": "860:48:6",
															"typeDescriptions": {
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bytes32",
																"typeString": "bytes32"
															}
														],
														"id": 872,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "852:7:6",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_uint256_$",
															"typeString": "type(uint256)"
														},
														"typeName": "uint256"
													},
													"id": 881,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "852:57:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "%",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 882,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 789,
														"src": "912:5:6",
														"typeDescriptions": {
															"typeIdentifier": "t_array$_t_address_$dyn_storage",
															"typeString": "address[] storage ref"
														}
													},
													"id": 883,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "912:12:6",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "852:72:6",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 871,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "837:5:6",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_uint8_$",
												"typeString": "type(uint8)"
											},
											"typeName": "uint8"
										},
										"id": 885,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "837:95:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"functionReturnParameters": 870,
									"id": 886,
									"nodeType": "Return",
									"src": "824:108:6"
								}
							]
						},
						"documentation": null,
						"id": 888,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "random2",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 867,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "792:2:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 870,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 869,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 888,
									"src": "811:5:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint8",
										"typeString": "uint8"
									},
									"typeName": {
										"id": 868,
										"name": "uint8",
										"nodeType": "ElementaryTypeName",
										"src": "811:5:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint8",
											"typeString": "uint8"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "810:7:6"
						},
						"scope": 911,
						"src": "776:161:6",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 909,
							"nodeType": "Block",
							"src": "1014:61:6",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 900,
												"name": "_owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 890,
												"src": "1031:6:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 897,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 789,
												"src": "1020:5:6",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_address_$dyn_storage",
													"typeString": "address[] storage ref"
												}
											},
											"id": 899,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "push",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1020:10:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_arraypush_nonpayable$_t_address_$returns$_t_uint256_$",
												"typeString": "function (address) returns (uint256)"
											}
										},
										"id": 901,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1020:18:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 902,
									"nodeType": "ExpressionStatement",
									"src": "1020:18:6"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 906,
												"name": "_dragonDen",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 892,
												"src": "1059:10:6",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 903,
												"name": "dragonDen",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 792,
												"src": "1044:9:6",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_address_$dyn_storage",
													"typeString": "address[] storage ref"
												}
											},
											"id": 905,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "push",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "1044:14:6",
											"typeDescriptions": {
												"typeIdentifier": "t_function_arraypush_nonpayable$_t_address_$returns$_t_uint256_$",
												"typeString": "function (address) returns (uint256)"
											}
										},
										"id": 907,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "1044:26:6",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 908,
									"nodeType": "ExpressionStatement",
									"src": "1044:26:6"
								}
							]
						},
						"documentation": null,
						"id": 910,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 895,
								"modifierName": {
									"argumentTypes": null,
									"id": 894,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 2896,
									"src": "1004:9:6",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "1004:9:6"
							}
						],
						"name": "setAccount",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 893,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 890,
									"name": "_owner",
									"nodeType": "VariableDeclaration",
									"scope": 910,
									"src": "961:14:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 889,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "961:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 892,
									"name": "_dragonDen",
									"nodeType": "VariableDeclaration",
									"scope": 910,
									"src": "977:18:6",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 891,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "977:7:6",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "960:36:6"
						},
						"payable": false,
						"returnParameters": {
							"id": 896,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1014:0:6"
						},
						"scope": 911,
						"src": "941:134:6",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 912,
				"src": "137:940:6"
			}
		],
		"src": "0:1078:6"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.797Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/DragonFactory.json
// module id = 1031
// module chunks = 0